:host {
    display: inline-block;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
}
:host *,
:host *::before,
:host *::after {
    box-sizing: inherit;
}

.image-viewer__wrapper {
    width: 100%;
    height: 100%;
}
.iv-image-mode {
    width: 100%;
    height: 100%;
    display: block;
}
.iv-image-mode > img {
    display: block;
    width: 100%;
    height: 100%;
}
.image-viewer__controls {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    display: flex;
    flex-direction: column;
}
.image-viewer__controls button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 1px;
    cursor: pointer;
    border: none;
    color: black;
    background: rgba(255,255,255,0.8);
    width: 2rem;
    height: 2rem;
    transition: all 0.2s ease;
}
.image-viewer__controls button:hover {
    background: rgba(255,255,255,1);
}
.image-viewer__controls button.zoom-reset {
    margin-top: 1rem;
}
